import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Asset } from "../models/asset";
import { fromJson } from "../models/modelHelpers";
import { httpClient, Service } from "./client";
import { CMSAsset } from "@client/models/CMS/cmsAsset";

export type CmsSpecificParams = {
  type?: string[] | string;
  sourceType?: string;
  tagIds?: string[] | string;
  assetIds?: string[] | string;
  page?: number;
  pageSize?: number;
};
class AssetService extends Service {
  getAssetsByQuery(
    query?: string,
    sort?: string,
    cmsSpecificParams?: CmsSpecificParams
  ): Observable<Array<Asset | CMSAsset>> {
    const params = new URLSearchParams();
    if (query) params.append("query", query);
    if (sort) params.append("sort", sort);

    if (cmsSpecificParams) {
      if (cmsSpecificParams.page !== undefined) {
        params.append("page", cmsSpecificParams.page.toString());
      }
      if (cmsSpecificParams.pageSize !== undefined) {
        params.append("pageSize", cmsSpecificParams.pageSize.toString());
      }

      if (cmsSpecificParams.type) {
        (Array.isArray(cmsSpecificParams.type)
          ? cmsSpecificParams.type
          : [cmsSpecificParams.type]
        ).forEach((t) => params.append("type", t));
      }
      if (cmsSpecificParams.sourceType) {
        (Array.isArray(cmsSpecificParams.sourceType)
          ? cmsSpecificParams.sourceType
          : [cmsSpecificParams.sourceType]
        ).forEach((st) => params.append("sourceType", st));
      }
      if (cmsSpecificParams.tagIds) {
        (Array.isArray(cmsSpecificParams.tagIds)
          ? cmsSpecificParams.tagIds
          : [cmsSpecificParams.tagIds]
        ).forEach((tag) => params.append("tagId", tag));
      }
      if (cmsSpecificParams.assetIds) {
        (Array.isArray(cmsSpecificParams.assetIds)
          ? cmsSpecificParams.assetIds
          : [cmsSpecificParams.assetIds]
        ).forEach((id) => params.append("assetIds", id));
      }
    }

    return httpClient
      .get(`/assets?${params.toString()}`, this.authHeader())
      .pipe(
        map((assets) => {
          if (cmsSpecificParams) {
            // Instantiate as CMSAsset
            return assets.map((asset) => new CMSAsset(asset));
          }
          // Instantiate as Asset (RedBee)
          return assets.map((asset) => fromJson(Asset, asset));
        })
      );
  }

  getEpg(channelId: string) {
    return httpClient.get(`/assets/epg/${channelId}`, this.authHeader());
  }

  getChannels(): Observable<Array<Asset>> {
    return httpClient.get("/assets/channels", this.authHeader()).pipe(
      map((assets) => {
        return assets.map((asset) => fromJson(Asset, asset)) as Array<Asset>;
      })
    );
  }
}

export const assetService = new AssetService();
